module.exports = "pegasus/assets/blocks/header-8-theme5.png";